import api, { API_URL } from "@/plugins/axios";

export const getAll = async () => {
  const response = await api.get("/evento");
  return response.data;
};

export const reunionesPorEvento = async (idEvento) => {
  const response = await api.get(`/reunion/porEvento/${idEvento}`);
  return response.data;
};

export const getById = async (id) => {
  const response = await api.get(`/evento/${id}`);
  return response.data;
};

export const create = async (data) => {
  const response = await api.post("/evento", data);
  return response.data;
};

export const update = async (id, data) => {
  const response = await api.put(`/evento/${id}`, data);
  return response.data;
};

export const remove = async (id) => {
  await api.delete(`/evento/${id}`);
};

export const agendaPorMes = (idEvento, idMesa) => {
  const url = `${API_URL}/api/pdf/agendaPorMesa/${idEvento}/${idMesa}`;
  console.log(url);
  window.open(url, "_blank", { timeout: 30000 });
};
